module.exports = __webpack_public_path__ + "media/img/seed/5-49d9cb0fd813e2a12b09ff008d82baea.jpeg";